import getCollection from './getCollection';

export default async function getExportFields() {
    return getCollection('exportFields');
}
